export enum Steps {
  Create,
  Review,
  Success,
}

export const stepLabels = {
  [Steps.Create]: 'Create revaluation',
  [Steps.Review]: 'Review and approve',
};
